module.exports = __webpack_public_path__ + "img/ic_site.b8f3faa8.svg";